export const PowerBtn = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="power-off"
      className="prefix__svg-inline--fa prefix__fa-power-off prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
      />
    </svg>
  );
};

export const Github = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fab"
      data-icon="github"
      className="prefix__svg-inline--fa prefix__fa-github prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
      />
    </svg>
  );
};

export const Twitter = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fab"
      data-icon="twitter"
      className="prefix__svg-inline--fa prefix__fa-twitter prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
      />
    </svg>
  );
};

export const Facebook = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fab"
      data-icon="facebook"
      className="prefix__svg-inline--fa prefix__fa-facebook prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
      />
    </svg>
  );
};

export const Linkedin = (props) => {
  return (
    <svg viewBox="0 0 19 18" className="prefix__d-block" {...props}>
      <path
        fill={props.fill}
        d="M3.94 2A2 2 0 112 0a2 2 0 011.94 2zM4 5.48H0V18h4zm6.32 0H6.34V18h3.94v-6.57c0-3.66 4.77-4 4.77 0V18H19v-7.93c0-6.17-7.06-5.94-8.72-2.91z"
      />
    </svg>
  );
};

export const YinYang = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="yin-yang"
      className="prefix__svg-inline--fa prefix__fa-yin-yang prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
      />
    </svg>
  );
};

export const CenterLogo = (props) => {
  return (
    <svg viewBox="100 100 5 300" {...props}>
      <path d="m 58.063882,277.29357 -14.146175,6.54263 c 0,0 -4.639278,3.62917 0.207014,7.17487 4.846291,3.5457 14.12924,2.53401 14.12924,2.53401 l 13.256367,-6.59748 c 0,0 4.495607,-5.38705 1.632532,-7.89456 -2.862838,-2.50778 -15.920764,-1.22819 -15.078317,-1.75947 z" />
      <path d="m 45.876978,235.69165 -0.386324,4.64272 -5.022401,2.70863 -22.794484,-1.93462 v -6.57761 l 28.202389,1.16088 z" />
      <path d="m 10.425948,204.42397 c 0,0 -20.2983646,6.01214 -4.2498055,34.82372 0.2661486,0.47802 -4.2498056,-16.63732 8.4993465,-18.95882 12.749417,-2.32149 -3.090647,-15.47697 -4.249806,-15.86357 z" />
      <path d="m 3.7686602,185.87534 3.8619202,-1.7433 18.1597036,28.82721 -5.217932,18.37904 -4.440838,-0.5811 -12.363383,-44.88237 z" />
      <path d="m 120.82935,210.25354 c 1.54529,1.93462 1.06364,15.45842 -0.77271,25.14928 -1.46915,7.75386 -12.27421,18.4482 -21.59828,25.99988 -9.324066,7.55141 -14.765045,2.82575 -14.765045,2.82575 l -9.539969,-23.04614 1.214298,-1.00904 21.894622,-21.7949 23.567084,-8.12536 z" />
      <path d="m 98.529905,170.2415 c -7.581228,0.18549 -12.919282,4.80834 -12.676655,13.55004 l -0.044,8.10204 c -2.088655,0.28061 -5.276935,0.97168 -5.276935,2.64238 0,1.59121 3.213945,3.46992 5.504745,4.04493 l 0.130282,4.07778 c 0,0 3.972783,4.54971 8.858657,5.13771 l 3.304963,10.52078 17.868128,-11.27094 -5.17904,-10.69991 c 1.80729,-0.81482 4.39665,-2.53613 5.48861,-6.03493 1.76329,-5.65097 1.47359,-11.74737 -5.57963,-16.69111 -2.20406,-1.5451 -8.9539,-3.46277 -12.400156,-3.3785 z" />
      <path d="m 101.32395,186.67029 -13.605623,0.4086 -2.543533,0.12189 1.391731,8.45923 0.743861,-0.14309 -0.383916,-6.87306 13.55641,-1.02945 c 2.93401,-0.21198 2.42489,2.1943 2.6405,3.865 0.24856,1.92721 -2.71519,2.64398 -1.22382,2.40311 1.4914,-0.24113 2.97714,-1.43354 2.23153,-5.04655 -0.37286,-1.80637 -1.63515,-2.21656 -2.80754,-2.16277 z" />
      <path d="M 8.4066157,184.55044 21.54233,187.25881 33.519416,227.49872 20.769999,230.59396 8.4066157,184.55097 Z" />
      <path d="m 47.313689,234.36675 -11.589994,-3.86924 -18.158381,3.86924 24.725709,4.64299 5.022401,-4.64299 z" />
      <path d="m 73.896802,223.76754 c -1.756623,0.0318 -6.517321,0.67729 -7.773054,1.35431 -5.022401,2.70837 -10.42131,8.8159 -10.42131,8.8159 l -2.248122,-1.69296 -0.01667,-0.0662 -2.377901,-2.62251 c -0.303376,0.45285 -12.103029,-0.10334 -16.63171,0.29042 0,0 -0.792731,3.48529 4.465974,3.49059 2.054945,-0.55196 3.664537,-0.12189 5.656353,0.43933 l -5.656353,6.91652 c 0,0 3.05678,2.50036 5.761129,-2.5295 0.557169,-1.03634 4.265681,-0.55858 4.825019,-0.71624 0.827286,2.59998 2.053941,5.43156 3.517957,5.43156 2.704349,0 32.840609,-3.1045 34.772098,-7.74776 1.931701,-4.64272 -3.864566,-11.99301 -4.250864,-12.38014 0,0 -1.612661,0.56944 -6.882716,0.62376 l -2.740069,0.39191 h 2.83e-4 z" />
      <path d="m 93.968415,196.20958 c -0.161901,0.49313 -0.797176,1.72555 -3.387515,3.60453 -1.454543,1.05515 -3.185634,1.20486 -4.690608,1.04402 v 1.28833 c 2.267939,0.57263 4.427344,-0.13779 5.586237,-0.995 1.623033,-1.20327 2.354777,-4.31096 2.491859,-4.94188 z" />
      <path d="m 85.607448,190.64499 4.054275,1.64314 c 0,0 -2.799336,-6.47691 -4.054275,-1.64314 z" />
      <path d="m 74.857255,242.84612 -23.474209,6.04208 c -6.217544,1.60022 -14.534854,7.41521 -6.581616,18.12599 7.952708,10.7113 9.38254,15.78673 11.407957,17.30242 5.964598,4.46306 17.414096,-7.48411 17.414096,-7.48411 l -7.651079,-11.68563 c 0,0 22.81618,0.49445 25.009876,-0.0556 2.193854,-0.54904 -14.479555,-21.69632 -16.125025,-22.24616 z" />
      <path d="m 78.177829,239.66636 c -6.750158,0 -12.204367,5.51079 -12.204367,12.30145 h 48.692048 c 0,-6.78986 -5.45394,-12.30145 -12.20436,-12.30145 H 78.178093 Z m 0,2.01146 h 24.283051 c 5.67461,0 10.20514,4.57727 10.20514,10.28999 H 67.974538 c 0,-5.71272 4.530269,-10.28999 10.205143,-10.28999 z" />
      <path d="m 76.35482,241.25624 c -7.157887,0 -12.909227,5.78399 -12.909227,12.95304 v 5.52696 c 0,7.16851 5.751604,12.95303 12.909227,12.95303 h 27.98014 c 7.15788,0 12.90922,-5.78452 12.90922,-12.95303 v -5.52696 c 0,-7.16852 -5.7516,-12.95304 -12.90922,-12.95304 z m -1.751622,7.69 h 31.938362 c 4.58398,0 8.27815,3.69965 8.27815,8.2907 v 3.53245 c 0,1.46508 -0.37021,2.82072 -1.03183,4.01313 -0.47343,-1.78226 -3.28195,-3.16042 -6.71868,-3.17208 l -33.089318,-0.098 c -3.34227,0 -6.125996,1.24938 -6.742749,2.95585 -0.556084,-1.11795 -0.887797,-2.36177 -0.887797,-3.70071 v -3.53272 c 0,-4.59078 3.670358,-8.29044 8.254338,-8.29044 z" />
      <path d="m 84.990959,170.77146 c 0,0 -2.001685,3.88303 1.000882,4.08733 3.002539,0.20668 3.102553,-0.8172 3.102553,-0.8172 0,0 7.406336,-2.75871 8.40727,1.73694 1.000882,4.49566 -0.600508,5.00654 -0.600508,5.00654 0,0 1.901618,2.14581 1.401203,3.57671 -0.500441,1.4301 4.003211,0.20403 4.003211,0.20403 0,0 3.60289,-1.12378 3.80318,2.45213 0.20019,3.57671 0.20019,5.00733 0.20019,5.00733 l 6.80572,3.37161 c 0,0 4.00321,-1.83922 4.90413,-5.92655 0.90076,-4.08679 0.70057,-12.0566 -2.80251,-14.91786 -3.50288,-2.86099 -13.11137,-7.76525 -18.115254,-6.2326 -5.004409,1.53238 -11.209517,5.61943 -12.110173,2.45212 z" />
      <path d="m 110.40195,206.54381 c 0,0 8.49935,-2.32149 11.20369,3.86898 2.70435,6.19074 0.77271,12.38174 -5.79499,15.47671 -6.56786,3.0955 -24.72571,11.22059 -24.72571,11.22059 0,0 -0.772702,1.16062 -3.863508,0.38714 -3.090648,-0.77401 -5.408699,-12.38174 -5.794997,-16.25072 -0.386377,-3.86897 8.113049,-5.8036 11.977085,-6.96448 3.863508,-1.16087 18.15838,-8.51196 16.99869,-7.73822 z" />
    </svg>
  );
};

export const Design = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="palette"
      className="prefix__svg-inline--fa prefix__fa-palette prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
      />
    </svg>
  );
};

export const Develope = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="laptop-code"
      className="prefix__svg-inline--fa prefix__fa-laptop-code prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
      />
    </svg>
  );
};
